import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgLoadReload32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" fillRule="evenodd" d="M19.037 24.15h-5.273l3.011 3.004c.2.19.2.512 0 .703-.2.19-.51.19-.71 0l-4.212-4.219 4.212-4.218c.2-.19.51-.19.71 0 .2.19.2.512 0 .703l-3.011 3.003h5.273a4.96 4.96 0 0 0 4.962-4.962v-4.439c0-.281.22-.502.5-.502s.501.22.501.502v4.44a5.958 5.958 0 0 1-5.963 5.956zm-3.812-11.58a.487.487 0 0 1 0-.703l3.011-3.003h-5.273a4.96 4.96 0 0 0-4.962 4.961v6.268c0 .281-.22.502-.5.502S7 20.375 7 20.093v-6.267a5.953 5.953 0 0 1 5.953-5.977h5.273l-3.011-3.003a.487.487 0 0 1 0-.703c.2-.19.51-.19.71 0l4.212 4.219-4.212 4.218c-.2.19-.51.19-.71 0z" clipRule="evenodd" /></SvgIcon>;
};
const Memo = memo(SvgLoadReload32);
export default Memo;